module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs-about-team"
  }, [_c('div', {
    staticClass: "tabs-about-team__bg"
  }, [_c('div', {
    staticClass: "tabs-about-team__container"
  }, [_c('div', {
    directives: [{
      name: "waypoint",
      rawName: "v-waypoint",
      value: ({
        active: true,
        callback: _vm.onWaypointTitle,
        options: _vm.intersectionTitleOptions
      }),
      expression: "{ active: true, callback: onWaypointTitle, options: intersectionTitleOptions }"
    }],
    staticClass: "tabs-about-team__title",
    class: {
      "tabs-about-team__title--active": _vm.fadeTitle
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.title)
    }
  })]), _c('div', {
    staticClass: "tabs-about-team__team-container"
  }, _vm._l((_vm.props.team_member), function(member, i) {
    return _c('div', {
      staticClass: "tabs-about-team__team-member",
      on: {
        "key": i,
        "click": function($event) {
          _vm.displayBio(i)
        }
      }
    }, [_c('div', {
      staticClass: "tabs-about-team__team-member--overlay",
      class: {
        "tabs-about-team__team-member--overlay-active": _vm.showBio === i
      },
      staticStyle: {
        "background-image": "url(https://coosmiles.com/static/CircleOverlay.svg)"
      }
    }), _c('div', {
      staticClass: "tabs-about-team__team-member--image",
      style: ("background-image: url(" + member.image + ");")
    }, [_c('div', {
      staticClass: "tabs-about-team__team-member--content",
      class: {
        "tabs-about-team__team-member--content-active": _vm.showBio === i
      }
    }, [_c('div', {
      staticClass: "tabs-about-team__team-member--name",
      domProps: {
        "innerHTML": _vm._s(member.name)
      }
    }), _c('div', {
      staticClass: "tabs-about-team__team-member--bio",
      domProps: {
        "innerHTML": _vm._s(member.bio)
      }
    })])])])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50082427","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/tabs/tabs-about-team/tabs-about-team.pug
// module id = 578
// module chunks = 1